const workExperience = [
  {
    title: "Teaching Assistant",
    startDate: "10/2019",
    endDate: "Current",
    company: "2U/Trilogy",
    description: "",
    achievements: [
      "Providing effective guidance, training, lesson plans, and tools to support student learning",
      "Tracking student progress throughout the course length",
      "Helping students learn to answer their own questions as developers",
      "Continuous mentoring for all students throughout their careers",
    ],
  },
  {
    title: "Digital Development Engineer",
    startDate: "02/2020",
    endDate: "09/2020",
    company: "Gray Television",
    description: "",
    achievements: [
      "Developed content management system",
      "Created features for a content management system used by dozens of news websites, utilizing React functional components and hooks",
      "Designed features for three target audiences:  curators, editors, and readers",
      "Deployed over 60 websites using CI/CD pipeline",
      "Wrote tests for React components using Jest/Enzyme",
    ],
  },
  {
    title: "Full Stack Engineer",
    startDate: "11/2019",
    endDate: "01/2020",
    company: "Private Contract",
    description: "",
    achievements: [
      "Contributed to full stack e-commerce applications",
      "Developed UI/UX, microservices, REST APIs",
      "Utilized React, Redux, AWS, Node, and Express",
    ],
  },
];

export default workExperience;
